import { t } from "@redotech/redo-i18n";
import StopIcon from "@redotech/redo-icons/slash-octagon_filled.svg";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

/**
 * Editor-internal synthetic "End" marker for the last phase of a multi-phase
 * flow (Compensation → Delivered). Lives only at render time — never
 * persisted to the AdvancedFlow document. The editor injects exactly one End
 * step at the bottom of the last phase to make the flow's terminal point
 * explicit (unlike earlier phases, Delivered has no "next phase" anchor to
 * fall through to).
 */
export const END_NODE_STEP = Symbol("end_node_step");

export interface EndNodeStepModel {
  type: typeof END_NODE_STEP;
}

export interface EndNodeState {
  // Intentionally empty — the End marker has no configuration.
}

export const END_NODE = (
  Details: React.ComponentType<StepTypeDetailsProps<EndNodeState>>,
): StepType<EndNodeState, EndNodeStepModel> => ({
  Details: (props) => React.createElement(Details, props),
  get title() {
    return t("End");
  },
  customTitle: () => undefined,
  description: () => t("Flow ends here"),
  Icon: StopIcon,
  iconColor: "gray",
  empty: {},
  downstream: () => [],
  maxDownstream: () => 0,
  layout: () => BlockLayout.FULL,
  fromModel() {
    return {};
  },
  toModel() {
    return { type: END_NODE_STEP };
  },
  stepDeleted(state) {
    return produce(state, () => {});
  },
  valid: () => true,
});
